import { API_TAX_CHANGE_SEND_AUTO, API_TAX_CHANGE_SEND_FAX, API_TAX_CHANGE_SEND_GOV } from '@/constants/constant';
import { ptax } from '@/proto/proto';

enum TaxChangeRequestMethod {
  AUTO = 0, // 자동
  GOV = 1, // 문서24
  FAX = 2, // 팩스 발송
  EXCEPT = 3, // 개별 처리
}

export const allCases = [TaxChangeRequestMethod.GOV, TaxChangeRequestMethod.FAX];

export const apiOf = (method: TaxChangeRequestMethod) => {
  switch (method) {
    case TaxChangeRequestMethod.AUTO:
      return API_TAX_CHANGE_SEND_AUTO;
    case TaxChangeRequestMethod.GOV:
      return API_TAX_CHANGE_SEND_GOV;
    case TaxChangeRequestMethod.FAX:
      return API_TAX_CHANGE_SEND_FAX;
    default:
      return '';
  }
};

export const nameOf = (method: TaxChangeRequestMethod) => {
  switch (method) {
    case TaxChangeRequestMethod.GOV:
      return '문서24';
    case TaxChangeRequestMethod.FAX:
      return '웹팩스';
    case TaxChangeRequestMethod.EXCEPT:
      return '개별처리';
    default:
      return '';
  }
};

export const hintOf = (method: TaxChangeRequestMethod) => {
  switch (method) {
    case TaxChangeRequestMethod.GOV:
      return '기관명을 입력하세요';
    case TaxChangeRequestMethod.FAX:
      return '팩스 번호를 입력하세요';
    case TaxChangeRequestMethod.EXCEPT:
      return '메모를 입력하세요';
    default:
      return '';
  }
};

export const methodOf = (tax?: ptax.IPbTaxNotice) => {
  if (tax?.contact?.org) {
    return TaxChangeRequestMethod.GOV;
  }
  if (tax?.contact?.fax) {
    return TaxChangeRequestMethod.FAX;
  }
  return TaxChangeRequestMethod.EXCEPT;
};

export const valueOf = (tax: ptax.IPbTaxNotice) => {
  if (tax.contact?.org) {
    return TaxChangeRequestMethod.GOV;
  }
  if (tax.contact?.fax) {
    return TaxChangeRequestMethod.FAX;
  }
  return undefined;
};

export default TaxChangeRequestMethod;
